import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserData } from "./redux/slices/categorySlice";

import socket from "./socket";
import { addNotification } from "./redux/slices/notificationSlice";

// ================= AUTH / FORMS =================
import Signup from "./Components/Forms/Signup";
import Login from "./Components/Forms/Login";
import ForgotPassword from "./Components/Forms/ForgotPassword";
import ResetPassword from "./Components/Forms/Reset Password Form";
import RegistrationForm from "./Components/Forms/Registrationform";
import BookAppointment from "./Components/Forms/BookAppointment";
import PaymentPage from "./Components/Forms/PaymentPage";

// ================= HOME =================
import Home from "./Pages/Home/Home";
import About from "./Pages/AboutUs";
import Legal from "./Pages/Legal & Policies"



// ================= DASHBOARD =================

import BusinessUserDashboard from "./Components/Dashboard/BusinessUserDashboard";
import UserDashboard from "./Components/Dashboard/UserDashboard";
import UserCard from "./Pages/Body/UserCardListPage";
import Labusershome from "./Components/Dashboard/Labusershome";
import HomeSummary from "./Components/Dashboard/HomeSummary";
import OtherMedicalServices from "./Components/Dashboard/Otherserviceuserdashboard";
import PatientsView from "./Components/Dashboard/PatientsView";

// ================= PROFILE =================
import ProfileEditorPage from "./Components/Dashboard/useProfileEditorPage";
import ChangePasswordPage from "./Components/Dashboard/ChangePasswordPage";
import BusinessUserProfileEditorPage from "./Components/Dashboard/BuserupdateEditorPage";
import BusinessChangePassword from "./Components/Dashboard/Buschangepassword";
import LandingPage from "./Pages/LandingPage.jsx";
// ================= CATEGORY =================
import CategorySelector from "./Components/Allcategories/CategorySelector";
import LocationInformation from "./Components/location/LocationInformation";

// ================= PAYMENT =================
import PlanPayment from "./Pages/phonepay/PlanPayment.jsx";
import PaymentStatus from "./Pages/phonepay/PaymentStatus.jsx";

// ================= AVAILABILITY =================
import AllAvailabilities from "./Components/availability/AllAvailabilities.jsx";
import AlternativeAvailability from "./Components/availability/AlternativeAvailability";
import OtherMedicalAvailability from "./Components/availability/OtherMedicalAvailability";
import DoctorAvailability from "./Components/availability/DoctorAvailability";
import OpeningClosingManager from "./Components/availability/OpeningClosingManager.jsx";
import DoctorSlotManager from "./Components/availability/DoctorSlotManager.jsx";
import OtherMedicalAvailabilitySlot from "./Components/availability/OtherMedicalAvailabilitySlot";
import SearchBar from "./Components/SearchBar/SearchBar";
import AlternativeAvailSlots from "./Components/availability/AlternativeMedicalAvailabilitySlots.jsx";

function App() {
  const dispatch = useDispatch();

  const { categories, loading, error } = useSelector(
    (state) => state.category
  );

  const user = useSelector((state) => state.auth.user);

  // ================= FETCH DATA =================
  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  // ================= SOCKET REALTIME (FIXED) =================
  useEffect(() => {
    if (!user?._id) return;

    console.log("🟢 SOCKET CONNECTED FOR USER:", user._id);

    socket.connect();
    socket.emit("join", user._id);

    // ✅ IMPORTANT: named handler (prevents duplicate bugs)
    const handleNotification = (data) => {
      console.log("🔥 REALTIME NOTIFICATION:", data);
      dispatch(addNotification(data));
    };

    socket.on("notification", handleNotification);

    // cleanup
    return () => {
      console.log("🔴 SOCKET CLEANUP");

      socket.off("notification", handleNotification);
      socket.disconnect();
    };
  }, [user?._id, dispatch]);

  return (
    <Routes>
      {/* ================= PUBLIC ================= */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/sign-up" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/RegistrationForm" element={<RegistrationForm />} />
      <Route path="/location-information" element={<LocationInformation />} />
      <Route path="/PatientsView" element={<PatientsView />} />
      <Route path="/HomeSummary" element={<HomeSummary />} />
      <Route path="/book-appointment" element={<BookAppointment />} />
      <Route path="/about" element={<About />} />
      <Route path="/legal-policies" element={<Legal />} />
     <Route path="/search" element={<SearchBar />} />
      <Route path="/Home" element={<Home />} />

      {/* ================= PAYMENT ================= */}
      <Route path="/select-plan" element={<PlanPayment />} />
      <Route path="/checkout" element={<PaymentPage />} />
      <Route path="/payment-status/:transactionId" element={<PaymentStatus />} />

      {/* ================= DASHBOARD ================= */}
     
      <Route path="/dashboard/business-user" element={<BusinessUserDashboard />} />
      <Route path="/dashboard/user" element={<UserDashboard />} />
      <Route path="/dashboard/medical-service" element={<OtherMedicalServices />} />

      {/* ================= PROFILE ================= */}
      <Route path="/edit-profile" element={<ProfileEditorPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="/business/edit-profile" element={<BusinessUserProfileEditorPage />} />
      <Route path="/business/change-password" element={<BusinessChangePassword />} />

      {/* ================= USERS ================= */}
      <Route path="/UserCard/:subcategory" element={<UserCard />} />
      <Route path="/Labusershome" element={<Labusershome />} />

      {/* ================= CATEGORY ================= */}
      <Route
        path="/category-selector"
        element={
          <CategorySelector
            categories={categories}
            loading={loading}
            error={error}
          />
        }
      />

      {/* ================= AVAILABILITY ================= */}
      <Route path="/availabilities" element={<AllAvailabilities />} />
      <Route path="/availabilities/alternative" element={<AlternativeAvailability />} />
      <Route path="/availabilities/other-medical" element={<OtherMedicalAvailability />} />
      <Route path="/availabilities/doctor" element={<DoctorAvailability />} />

      <Route
        path="/availabilities/other-medical/slots"
        element={<OtherMedicalAvailabilitySlot />}
      />
      <Route path="/alternative-avail-slots" element={<AlternativeAvailSlots />} />
      <Route
        path="/dashboard/availability/opening-closing"
        element={<OpeningClosingManager />}
      />
      <Route path="/doctor/slots/:id" element={<DoctorSlotManager />} />
    </Routes>
  );
}

export default App;
